<template>
  <div>
    <template v-if="$route.name == 'score'">
      <ots-main-title :mainTopBtn="mainBtnArr" ref="mainTitle" :isShowSearchIcon="false"></ots-main-title>
      <ots-refer
        class="mb20"
        :selectList="teaSelectList"
        :request-form="requestForm"
        @search="getScoreList"
      />
      <ots-table-group-new
        :tableHeader="tableHeader"
        :tableData="tableData"
        :batchOperBtn="batchOperBtn"
      ></ots-table-group-new>
      <ots-custom-dialog
        :dialog.sync="addDialog"
        :title="form.code ? '修改' : '添加课程'"
        width="40%"
      >
        <template v-slot:content>
          <div>
            <el-form ref="form" :model="form" :rules="rules">
              <el-form-item
                label="课程名称"
                class="childrenName"
                prop="courseName"
              >
                <el-input v-model="courseName" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="启用状态">
                <el-radio-group>
                  <el-radio-button label="1">启用</el-radio-button>
                  <!-- <el-radio-button label=0>停用</el-radio-button> -->
                </el-radio-group>
              </el-form-item>
              <el-form-item label="通过分数设置 大于等于" prop="passScore">
                <el-input v-model="form.passScore"></el-input>分
              </el-form-item>
              <el-form-item label="优秀分数设置 大于等于" prop="excellentScore">
                <el-input v-model="form.excellentScore"></el-input>分
              </el-form-item>
              <el-form-item label="成绩计算方式">
                <el-radio-group v-model="form.scoreCalculateType" >
                  <el-radio-button label=1>原始成绩</el-radio-button>
                  <el-radio-button label=2 :disabled="haveSubCourseFlag">赋分后成绩</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="成绩显示方式">
                <el-radio-group v-model="form.scoreType" @change="changeSwitchState">
                  <el-radio-button label="1">分数</el-radio-button>
                  <el-radio-button label="2" :disabled="haveSubCourseFlag">等级制</el-radio-button>
                  <el-radio-button label="3">合格/不合格</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <div class="courseSwitchCss" :style="arrowPositionStyle" v-if="isShowSwitch">
                <div class="switch1" v-if="form.scoreType == 2 || form.scoreType == 3">
                  <div>是否同时显示分数 <el-switch v-model="form.outputScore" :active-value="1" :inactive-value="0" @change="form.outputScoreSub = 0"></el-switch></div>
                  <div><font>（如开启，学生会在成绩查询页面看到具体分数）</font></div>
                </div>
                <div class="switch1" v-if="haveSubCourseFlag && form.scoreType == 3 && form.outputScore == 1">
                  <div>是否显示综合课的单科分数 <el-switch v-model="form.outputScoreSub" :active-value="1" :inactive-value="0"></el-switch></div>
                  <div><font>（如开启，学生会查询到综合课下的单科得分）</font></div>
                </div>
              </div>
              <!-- <el-form-item label="合格率百分比" class="rateStyle" v-if="form.scoreType == 3">
                            <el-input class="short" v-model="form.rate" placeholder="请输入"></el-input><em>%</em>
                        </el-form-item> -->

              <el-form-item
                label="等级设置"
                class="gradeStyle"
                v-if="form.scoreType == 2 && !haveSubCourseFlag"
              >
                <div
                  v-for="(item, index) in form.form_gradeList"
                  :key="index"
                  class="mb10"
                >
                  <el-input
                    class="input-w160"
                    placeholder="请输入等级名称"
                    v-model="item.name"
                  ></el-input>
                  <span class="span-w">分数≥</span>
                  <el-input
                    class="short"
                    placeholder="录入等级分数"
                    v-model="item.score"
                  ></el-input>
                  <i
                    v-if="index > 0"
                    class="ml42 iconfont icon-shanchu"
                    @click="deleteGrade(index)"
                  ></i>
                </div>
                <p class="col_blue mt10 cp" @click="addGrade">
                  <i class="el-icon-plus mr5"></i><span>增加等级</span>
                </p>
              </el-form-item>
            </el-form>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="cancelDialog">取消</el-button>
          <el-button round type="primary" @click="addCourse">确定</el-button>
        </template>
      </ots-custom-dialog>
    </template>

    <template v-else>
      <router-view />
    </template>
    <ots-custom-dialog :dialog.sync="importDialog" title="导入成绩" width="40%">
      <template v-slot:content>
        <div class="exportDialog">
          <el-form ref="exportForm" :model="importForm">
            <el-form-item label="1.模板下载">
              <span
                style="color: #006aff"
                @click="$getStaticFile('成绩导入.xlsx')"
                class="cp"
              >
                <i class="el-icon-download"></i>
                下载成绩导入数据模板
              </span>
            </el-form-item>
            <el-form-item label="2.选择文件" v-model="importForm.file">
              <ots-upload-file :httpRequest="handleFormData" fileType="xlsx" />
            </el-form-item>
          </el-form>
          <div class="impExplain">
            <span class="tipTitle"><i></i>提示：</span>
            <div>
              <div>1：模板中<span class="col_red">*</span>字段为必填项</div>
              <div>
                2：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="importDialog = false">取消</el-button>
        <el-button round type="primary" @click="scoreImport">确定</el-button>
      </template>
    </ots-custom-dialog>
    <ots-custom-dialog :dialog.sync="importDialogmsg" title="导入成绩" width="40%">
          <template v-slot:content>
            <div class="exportDialog">
              <el-form ref="exportForm" :model="importForm">
                <el-form-item label="1.模板下载">
                  <span style="color:#006AFF;" @click="getStaticFile" class="cp">
                      <i class="el-icon-download"></i>
                      下载考试异常状态导入数据模板
                  </span>
                </el-form-item>
                <el-form-item label="2.选择文件" v-model="importForm.file">
                  <ots-upload-file :httpRequest="handleFormData" fileType="xlsx" />
                </el-form-item>
              </el-form>
              <div class="impExplain">
                <span class="tipTitle"><i></i>提示：</span>
                <div>
                  <div>1：模板中<span class="col_red">*</span>字段为必填项</div>
                  <div>2：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；</div>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:footer>
            <el-button round @click="importDialogmsg=false">取消</el-button>
            <el-button round type="primary" @click="scoreImportmsg" >确定</el-button>
          </template>
    </ots-custom-dialog>

    <ots-custom-dialog :dialog.sync="publishScoreDialog" title="提示" width="40%">
      <template v-slot:content>
        <div class="exportDialog">
          <p>批次下存在未处理完成的 <span style="color: #FE5958; font-weight: 700;"> {{ exemptNum }}名 </span>免考学生，确定要成绩发布么？</p>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="publishScoreDialog = false">取消</el-button>
        <el-button round type="primary" @click="publishScoreFn" >确定</el-button>
      </template>
    </ots-custom-dialog>

    <ots-custom-dialog :dialog.sync="setSubCourseDialog" title="修改单科设置" width="60%">
      <template v-slot:content>
        <div class="setSubCourseDiv">
          <div>
            <div><span>综合课程名称：</span>{{ nowCourseName }}</div>
          </div>
          <div>
            <div><span>综合课的通过分数：</span>大于等于{{ corusePassScore }}分</div>
          </div>
          <div>
            <span>单科设置：</span>
          </div>
          <div>
            <div v-for="course in checkedCourseInfo" :key="course.id">
              <span class="specialSpanTitle">
                {{ course.name }}：
              </span>
              <span class="specialSpanContent">
                成绩计算方式：
                <el-select v-model="course.scoreCalculateType" placeholder="请选择">
                  <el-option label="原始成绩" :value="1"></el-option>
                  <el-option label="赋分后成绩" :value="2"></el-option>
                </el-select>                
              </span>
              <span class="specialSpanContent">
                分数线&gt;=
                <el-input 
                  v-model.number="course.passScore" 
                  placeholder="请输入单科通过分数线" 
                  maxlength="3"
                ></el-input> 分
              </span>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="setSubCourseDialog = false">取消</el-button>
        <el-button round type="primary" @click="editSubCourse" >确定</el-button>
      </template>
    </ots-custom-dialog>

    <el-dialog title="提示" :visible.sync="beforeData.dialogFlag == 1" width="35%" :show-close="false">
      <template slot="title">
        <slot name="title">
            <span class="beforeWarning-title">提示</span>
            <span class="beforeWarning-red">×</span>
        </slot>
      </template>
      <div class="beforePublishDialogCss">
        <div v-if="beforeData.forbidList && beforeData.forbidList.length">
          <ul>
            <li v-for="(item,index) in beforeData.forbidList" :key="index">
              {{ (index + 1) }}、{{ item }}
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button round type="primary" @click="beforeData.dialogFlag = 0" >去处理</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="beforeData.dialogFlag == 2" width="35%" :show-close="false">
      <template slot="title">
        <slot name="title">
            <span class="beforeWarning-title">提示</span>
            <span class="beforeWarning-blue">?</span>
        </slot>
      </template>
      <div class="beforePublishDialogCss">
        <div v-if="beforeData.askList && beforeData.askList.length">
          <span class="col_yellow">注意事项：</span>
          <ul>
            <li v-for="(item,index) in beforeData.askList" :key="index">
              {{ (index + 1) }}、{{ item }}
            </li>
          </ul>
        </div>
        <div>
          <span class="col_nomarl">课程的考核规则：</span>
          <span style="margin-left: 20px;"><el-link type="primary" :underline="false" @click="seeCourseRule()">点击查看</el-link></span>
        </div>
        <div class="confirm-date-box">
          <span class="confirm-date-label">合格证发证日期：</span>
          <span><el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="confirmDate" style="width: auto;"></el-date-picker></span>
        </div>
        <div>
          <span class="col_green">
            提示：<br>
            &nbsp;&nbsp;&nbsp;&nbsp;1、如果没有合格证的情况，无需设置。<br>
            &nbsp;&nbsp;&nbsp;&nbsp;2、成绩发布后无法取消，是否确认以上信息并进行成绩发布？
          </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="beforeData.dialogFlag = 0">取消</el-button>
        <el-button round type="primary" @click="checkNextStep" >确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="beforeData.dialogFlag == 3" width="35%" :show-close="false">
      <template slot="title">
        <slot name="title">
            <span class="beforeWarning-title">提示</span>
            <span class="beforeWarning-yellow">!</span>
        </slot>
      </template>
      <div class="beforePublishDialogCss">
        <div v-if="beforeData.windowList && beforeData.windowList.length">
          <ul>
            <li v-for="(item,index) in beforeData.windowList" :key="index">
              {{ (index + 1) }}、{{ item }}
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="beforeData.dialogFlag = 0">取消</el-button>
        <el-button round type="primary" @click="publishScoreFn" >确定</el-button>
      </span>
    </el-dialog>

    <el-drawer title="课程考核规则" :visible.sync="courseRuleDialog" direction="ltr" >
      <div style="margin-left: 50px;">
        <el-row>
          <el-col :span="20">
            <el-card shadow="hover" class="eCardCss" v-for="(item , name , index) in beforeData.infoList" :key="name">
              <div class="infoListCss">
                <div><strong>{{ index + 1 }}、{{ name }}</strong></div>
                <div class="cScore">
                    <span>通过分数：</span>
                    <span>>={{ item.passScore }}分</span>
                </div>
                <div class="cDiv" v-if="item.courseSubMap">
                  <div><strong>单科通过分数线：</strong></div>
                  <ul>
                    <li v-for="(subScore, courseSubName) in item.courseSubMap" :key="courseSubName">
                      <span>{{ courseSubName }}</span>
                      <span>>={{ subScore }}分</span>
                    </li>
                  </ul>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-drawer>

    <ots-custom-dialog :dialog.sync="certificateRuleSetDialog" title="合格证号的自定义规则设置" width="60%">
      <template v-slot:content>
        <div class="cert-plan-name-tip">批次：{{ currentPlan ? currentPlan.name : '' }}</div>
        <el-tabs v-model="certificateRuleActiveTab">
          <!-- 默认规则 -->
          <el-tab-pane label="默认规则" name="default">
            <h4 class="cert-custom-section-title">规则说明</h4>
            <div class="cert-default-rule-list">
              <div class="cert-default-rule-item" :class="['cert-bg-blue', 'cert-bg-orange', 'cert-bg-green'][index]" v-for="(item, index) in certSystemDefaultRules" :key="index">
                {{ item.value }}
              </div>
            </div>
            <div class="cert-default-rule-remark">
              批次下所有学生统一使用：{{ certSystemDefaultRules.map(item => item.value).join(' + ') }}
            </div>
          </el-tab-pane>

          <!-- 自定义规则 -->
          <el-tab-pane label="自定义规则" name="custom">
            <!-- 通用规则 -->
            <fieldset class="cert-custom-fieldset">
              <legend class="cert-custom-legend">通用规则</legend>
              <div class="cert-custom-rule-row">
                <span class="cert-rule-example">示例：{{ generateCertExample(certGeneralRule) }}</span>
                <el-form :inline="true" :model="certGeneralRule" label-width="100px" class="cert-custom-rule-form">
                  <el-form-item label="自定义前缀">
                    <el-input v-model="certGeneralRule.customPrefix" placeholder="请输入前缀" @keyup.native="certGeneralRule.customPrefix = certGeneralRule.customPrefix.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()"></el-input>
                  </el-form-item>
                  <el-form-item label="流水号位数">
                    <el-select v-model="certGeneralRule.numberLen" placeholder="请选择">
                      <el-option label="4位" :value="4"></el-option>
                      <el-option label="5位" :value="5"></el-option>
                      <el-option label="6位" :value="6"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="流水号起始号">
                    <el-input v-model.number="certGeneralRule.numberStart" placeholder="请输入起始号" type="number" :min="1"></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </fieldset>

            <!-- 按专业设置 -->
            <fieldset class="cert-custom-fieldset" v-if="certSubjectList.length > 0">
              <legend class="cert-custom-legend">按专业设置</legend>
              <el-collapse v-model="certExpandedSubjects" style="border: 0px ;">
                <el-collapse-item v-for="subject in certSubjectList" :key="subject.id" :name="subject.id">
                  <template slot="title">
                    <span class="cert-subject-title">{{ subject.name }}</span>
                    <span class="cert-subject-example" v-if="getCertSubjectRule(subject.id)">示例：{{ generateCertExample(getCertSubjectRule(subject.id)) }}</span>
                  </template>
                  <el-form :inline="true" :model="getCertSubjectRule(subject.id)" label-width="100px" class="cert-custom-rule-form" v-if="getCertSubjectRule(subject.id)">
                    <el-form-item label="自定义前缀">
                      <el-input v-model="getCertSubjectRule(subject.id).customPrefix" placeholder="请输入前缀" @keyup.native="getCertSubjectRule(subject.id).customPrefix = getCertSubjectRule(subject.id).customPrefix.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()"></el-input>
                    </el-form-item>
                    <el-form-item label="流水号位数">
                      <el-select v-model="getCertSubjectRule(subject.id).numberLen" placeholder="请选择">
                        <el-option label="4位" :value="4"></el-option>
                        <el-option label="5位" :value="5"></el-option>
                        <el-option label="6位" :value="6"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="流水号起始号">
                      <el-input v-model.number="getCertSubjectRule(subject.id).numberStart" placeholder="请输入起始号" type="number" :min="1"></el-input>
                    </el-form-item>
                  </el-form>
                </el-collapse-item>
              </el-collapse>
            </fieldset>
          </el-tab-pane>

          <!-- 直接导入 -->
          <el-tab-pane label="直接导入" name="import">
            <div class="cert-import-section">
              <div class="cert-import-row">
                <span class="cert-import-label">1.模板下载：</span>
                <el-button type="text" @click="downloadCertificateTemplate">
                  <i class="el-icon-download"></i> 下载导入模板
                </el-button>
              </div>
              <div class="cert-import-row">
                <span class="cert-import-label">2.文件导入：</span>
                <ots-upload-file :httpRequest="handleCertificateImportFile" fileType="xlsx" />
              </div>
              <div class="cert-import-row" style="margin-top: 16px;" v-if="certificateImportFile">
                <el-button type="primary" plain @click="doCertificateImport">导入</el-button>
              </div>
              <div class="cert-import-data-list" style="border-top: #d3d3d3 1px solid ; margin-top: 10px; padding-top: 16px;" v-if="certificateImportData.length > 0">
                <h4 class="cert-custom-section-title">已导入的合格证号</h4>
                <el-table :data="certificateImportData" border style="width: 100%">
                  <el-table-column prop="cardNo" label="证件号"></el-table-column>
                  <el-table-column prop="courseName" label="课程名称"></el-table-column>
                  <el-table-column prop="code" label="合格证号"></el-table-column>
                </el-table>
                <el-pagination
                  style="margin-top: 12px; text-align: right;"
                  @current-change="handleCertificateImportPageChange"
                  :current-page="certificateImportPagination.page"
                  :page-size="certificateImportPagination.size"
                  layout="total, prev, pager, next"
                  :total="certificateImportPagination.total">
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </template>
      <template v-slot:footer>
        <el-button round @click="certificateRuleSetDialog = false">取消</el-button>
        <el-button round type="primary" @click="saveCertificateRuleSet" v-if="certificateRuleActiveTab === 'custom'">保存</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>
<script>
import { mapMutations } from "vuex";
import {
  changeCourseScoreSets,
  getPlanCoursePublishFn,
  publishStudentScoreFn,
  getCourseScore,
  scoreImportecxel,
  getEnableScoreImportpland,
  importCheckStateFileexcel,
  getCheckStateTemplateexcel,
  exportSubCourseScoreAPI,
  publishPreJudgeExemptAPI,
  getPlanPartInfoAPI,
  editPlanCourseSubFn,
  getPlanCourseSubListFn,
  publishStudentScoreWarningFn
} from "@/http/modules/examSet/score";
import {
  getEnableSyncExamStateInfo,
  syncCheckStateSet,
  getEnableSyncCheckStateInfo,
} from "@/http/modules/examSet/journal";
import {
  getCurrentPlanFn,
  getSinglePlan,
  getSelectPlanFn,
  getPagePlan,
} from "@/http/modules/examSet/examBatch";
import { getPlanCourseFn } from "@/http/modules/baseSet/course";
import {
  getSubjectListByPlanIdCertAPI,
  getSystemDefaultRuleCertAPI,
  getCustomRuleByPlanIdCertAPI,
  saveCustomRuleByPlanIdCertAPI,
  certificateExportTemplateAPI,
  certificateImportAPI,
  certificateImportDataListAPI
} from "@/http/modules/examSet/planClass";
const scoreType = {
  1: "分数",
  2: "等级制",
  3: "合格/不合格",
};
const scoreCalculateType = {
  1: "原始成绩",
  2: "赋分后成绩"
};
export default {
  name: "score",
  data() {
    return {
      batchOperBtn: [
        {
          title: "成绩导出",
          icon: "iconfont icon-daochu",
          click: this.export,
        },
      ],

      mainBtnData: "",
      importForm: {
        file: "",
      },
      importDialogmsg: false,
      importDialog: false,
      setSubCourseDialog: false,
      getEnableScoreData: "",
      pLanCourseId: "",
      courseName: "",
      addDialog: false,
      form: {
        courseName: "",
        scoreCalculateType: 1,
        scoreType: 1,
        rate: 60,
        passScore: "",
        excellentScore: "",
        form_gradeList: [{ score: "", name: "" }],
        outputScore: 0,
        outputScoreSub: 0,
      },
      rules: {
        passScore: [
          { required: true, message: "请输入通过分数", trigger: "blur" },
          //{ type: "number", message: "通过分数只能为数字", trigger: "blur" },
        ],
        excellentScore: [
          { required: true, message: "请输入优秀分数", trigger: "blur" },
          // { type: "number", message: "优秀分数只能为数字", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入课程名称", trigger: "blur" },
          {
            min: 1,
            max: 30,
            message: "输入范围在 1 到 30 个字符",
            trigger: "blur",
          },
        ],
        rate: [
          // { required: true, message: '课程合格率必填', trigger: 'blur'},
          {
            type: "number",
            message: "课程合格率必须为数字值",
            trigger: "blur",
          },
        ],
      },
      currentPlanName: "",
      tableHeader: [
        {
          title: "考试课程",
          prop: "courseName",
        },
        {
            title:"成绩计算方式",
            prop:"scoreCalculateType",
            formatter: (val) => scoreCalculateType[val.row.scoreCalculateType]
        },
        {
          title: "成绩显示方式",
          prop: "scoreType",
          formatter: (val) => scoreType[val.row.scoreTypeId],
        },
        {
          title: "平均分",
          prop: "avgScore"
        },
        // {
        //   title: "是否为综合课",
        //   prop: "courseFlag",
        //   formatter: (val) => (val.row.courseFlag == 1 ? "是" : "否"),
        // },
        {
          title: "试算结果",
          prop: "scoreTotalTest",
        },
        {
          title: "成绩发布状态",
          prop: "placeNames",
          formatter: (val) => (val.row.scorePublish == 1 ? "已发布" : "未发布"),
        },
        {
          title: "显示设置",
          type: "buttons",
          // formatter: (val) => val.row.scoreTotalTest ? "修改设置" : "修改设置",
          // disableFn: (val) => (val.row.scoreTotalTest ? true : false),
          // click: this.changeSet,
          width: "190",
          fixed: "right",
          btnList: [
            {
              title : (scope) => scope.row.scoreTotalTest ? "修改设置" : "修改设置",
              disableFn: (scope) => scope.row.scoreTotalTest ? true : false,
              click: this.changeSet,
            },
            {
              title: "修改单科设置",
              formatter: (scope) => {return scope.row.haveSubCourse == 0 ? true: false},
              click: this.setSubCourse,
            },
          ],
        },
        {
          title: "操作",
          type: "buttons",
          width: "240",
          fixed: "right",
          btnList: [
            {
              title: (scope) => (scope.row.scorePublish == 1 ? "" : "试算"),
              disableFn: (scope) => scope.row.scorePublish == 1 ? true : false,
              click: this.checkSingleData,
            },
            {
              title: "查看详情",
              click: this.currentScore,
            },
            {
              title: "查看单科详情",
              formatter: (scope) => {return scope.row.haveSubCourse == 0 ? true: false},
              click: this.singleDetail,
            }
          ],
        },
      ],
      tableData: [],
      scoreListForm: {
        type: 0, // 0数据请求1试算数据请求
      },
      mainBtnArr: [
        {
          title: "成绩试算",
          fn: this.checkScore,
          plain: true,
        },
        {
          title: "设置合格证号规则",
          fn: this.openCertificateRuleSetDialog,
          plain: true,
        },
        {
          title: "一键发布",
          fn: this.publishScore,
        },
      ],
      teaSelectList: [
        {
          title: "考试批次",
          type: "select",
          isSearch: true,
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "课程",
          type: "select",
          multiple: true,
          requestKey: "courseIds",
          label: "courseName",
          value: "courseId",
          data: [],
        }, 
        {
          title: "成绩显示方式",
          type: "select",
          multiple: true,
          requestKey: "courseTypes",
          label: "name",
          value: "id",
          data: [
            {
              name: "分数",
              id: 1,
            },
            {
              name: "等级制",
              id: 2,
            },
            {
              name: "合格/不合格",
              id: 3,
            },
          ],
        },
      ],
      requestForm: {
        planId: null,
        courseIds: [],
        courseTypes: [],
        type: 0,
      },
      publishScoreDialog: false,
      exemptNum: 0,
      nowPlanId: "",
      nowCourseId: "",
      nowCourseName: "",
      corusePassScore: "",
      checkedCourseInfo: [],
      haveSubCourseFlag: false,
      courseRuleDialog: false,
      confirmDate: "",
      beforeData : {
        dialogFlag: 0,
        forbidList: [],
        askList: [],
        windowList: [],
        infoList: [],
      },
      // 合格证号的自定义规则
      certificateRuleSetDialog: false,
      certificateRuleActiveTab: 'default',
      certSystemDefaultRules: [],
      certSubjectList: [],
      certGeneralRule: {
        customPrefix: '',
        numberLen: 4,
        numberStart: 1,
      },
      certSubjectRules: [],
      certExpandedSubjects: [],
      certificateImportFile: null,
      certificateImportData: [],
      certificateImportPagination: {
        total: 0,
        page: 1,
        size: 10,
      },
    };
  },
  computed: {
    mainTopBtnList() {
      let btnArr;
      if (this.currentPlanFromStore.scorePublish == 1) {
        btnArr = [];
      } else {
        btnArr = this.mainBtnArr;
      }
      return btnArr;
    },
    arrowPositionStyle() {
      if(this.form.scoreType == 1) {
        return {'--arrow-position': `35px`,}
      }else if(this.form.scoreType == 2) {
        return {'--arrow-position': `120px`,}
      }else{
        return {'--arrow-position': `235px`,}
      }
    },
    isShowSwitch() {
      return this.form.scoreType == 2 || this.form.scoreType == 3;
    }
  },
  watch: {
    /******************************
     * @this 批次切换更新数据
     *****************************/
    "requestForm.planId"(val) {
      this.getCurrentInfo();
      this.initCourseList(val);
      this.getScoreList();
      this.isShowSyncBtn(val);
    },
    "certificateRuleActiveTab": function(val) {
      if (val === 'import') {
        this.certificateImportPagination.page = 1;
        this.getCertificateImportDataList();
      }
    }
    // "$route"(){
    //   this.$nextTick(() => {
    //     this.$refs["mainTitle"] && this.$refs["mainTitle"].hideSearchIcon();
    //   })
    // }
  },
  created() {
    this.planId = this.$route.query.id;
    this.initData();
    // this.isShowSyncBtn();
  },
  mounted() {
    // this.$refs["mainTitle"] && this.$refs["mainTitle"].hideSearchIcon();
    // this.SAVE_PAGE_THIS(this)
  },

  methods: {

    async export() {
      const { data, code } = await exportSubCourseScoreAPI({planId: this.requestForm.planId});
      if (code) {
        window.open(data);
      }
    },

    // 页面跳转 => 查看单科详情
    singleDetail(row) {
        this.$router.push({
          name: "singleGrades",
          query: {
            planCode: this.currentPlan.code,
            planName: this.currentPlan.name,
            planId: this.currentPlan.id,
            courseId: row.courseId,
            courseName: row.courseName,
            scorePublish: row.scorePublish,
          },
        });


      /* 
        this.$router.push({
          name: "currentScore",
          query: {
            planCode: this.currentPlan.code,
            planName: this.currentPlan.name,
            planId: this.currentPlan.id,
            courseId: row.courseId,
            courseName: row.courseName,
            scorePublish: row.scorePublish,
          },
        });
      */
    },

    getStaticFile(){
      getCheckStateTemplateexcel().then((res)=>{
      window.location.href = res.data
      })
    },
    deleteGrade(index) {
      this.form.form_gradeList.splice(index, 1);
    },
    importStationDialog() {
      this.importDialog = true;
    },
    importStationDialogmsg() {
      this.importDialogmsg = true;
    },
    handleFormData(val) {
      this.importForm.file = val.file;
    },
    async scoreImport() {
      // (1) 文件选择判断
      if (!this.importForm.file) {
        this.$message.error("请选择文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.importForm.file);
      formData.append("planId", this.requestForm.planId);
      const { code, data } = await scoreImportecxel(formData);
      if (code == 1) {
        const failNum = data.errorCount ? parseInt(data.errorCount) : 0;
        const totalNum = parseInt(data.allCount);
        const successNum = totalNum - failNum;
        let message = `导入完成，成功导入${successNum}，失败数${failNum}`;
        this.importDialog = false;
        this.$confirm(message, "导入结果", {
          confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
          cancelButtonText: "取消",
          type: failNum > 0 ? "warning" : "success",
        }).then(async () => {
          if (failNum > 0) {
            window.location.href = data.address;
          }
        });
        this.importDialog = false;
      } else {
        this.importDialog = false;
      }
    },
    async scoreImportmsg() {
      // (1) 文件选择判断
      if (!this.importForm.file) {
        this.$message.error("请选择文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.importForm.file);
      formData.append("planId",this.requestForm.planId);
      const { code, data } = await importCheckStateFileexcel(formData);
      if (code == 1) {
        const failNum = data.errorCount ? parseInt(data.errorCount) : 0;
        const successCount = data.successCount;
        let message = `导入完成，成功导入${successCount}，失败数${failNum}`;
        this.importDialog = false;
        this.$confirm(message, "导入结果", {
          confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
          cancelButtonText: "取消",
          type: failNum > 0 ? "warning" : "success",
        }).then(async () => {
          if (failNum > 0) {
            window.location.href = data.address;
          }
        });
        this.importDialogmsg = false;
      } else {
        this.importDialogmsg = false;
      }
    },
    addCourse() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let params = {
            name: this.form.name,
            scoreCalculateType: this.form.scoreCalculateType,
            scoreType: this.form.scoreType,
            planCourseId: this.form.planCourseId,
            passScore: this.form.passScore,
            excellentScore: this.form.excellentScore,
            outputScore: this.form.outputScore,
            outputScoreSub: this.form.outputScoreSub,
          };
          if (this.form.scoreType == 2) {
            // 等级制
            let gradeSet = this.form.form_gradeList.filter((item) => item.name);
            if (!gradeSet.length) {
              this.$message.error("请设置有效的等级制");
              return false;
            }
            params.gradeSet = JSON.stringify(gradeSet);
          }
          if (this.form.scoreType == 3) {
            // 合格率
            let rate = parseFloat(this.form.rate);
            if (isNaN(rate) || rate < 0) {
              this.$message.error("请设置有效的合格率");
              return false;
            }
            params.rate = parseInt(this.form.rate);
          }
          const { code } = await changeCourseScoreSets(params);
          if (code == 1) {
            this.$message.success("操作成功");
            // this.getScoreList();
            this.tableData.forEach((item) => {
              if (item.courseName == this.courseName) {
                item.scoreCalculateType = this.form.scoreCalculateType;
                item.scoreTypeId = this.form.scoreType;
              }
            });
            this.cancelDialog();
          }
        } else {
          return false;
        }
      });
    },
    cancelDialog() {
      this.resetForm();
      this.addDialog = false;
    },
    addGrade() {
      let obj = {
        score: "",
        name: "",
      };
      this.form.form_gradeList.push(obj);
    },
    ...mapMutations(["SAVE_PAGE_THIS"]),
    goHistory() {
      this.$router.push({
        name: "historyScore",
      });
    },

    /********************************
     * @isShowSyncBtn 是否展示异常同步按钮
     ********************************/
    isShowSyncBtn(val) {
      // 1. 是否展示按钮
      getEnableSyncCheckStateInfo({
        planId: this.requestForm.planId,
      }).then(({ data }) => {
        this.mainBtnData = data;
        getEnableScoreImportpland({ planId: val }).then((res) => {
          this.getEnableScoreData = res.data;
          if (this.mainBtnData == 1) {
            if (this.getEnableScoreData == 1) {
              this.mainBtnArr = [
                {
                  title: "同步考试异常状态",
                  fn: this.examErrSync,
                  plain: true,
                },
                {
                  title: "成绩导入",
                  fn: this.importStationDialog,
                  plain: true,
                },
                {
                  title: "考试异常状态导入",
                  fn: this.importStationDialogmsg,
                  plain: true,
                },
                {
                  title: "成绩试算",
                  fn: this.checkScore,
                  plain: true,
                },
                {
                  title: "设置合格证号规则",
                  fn: this.openCertificateRuleSetDialog,
                  plain: true,
                },
                {
                  title: "一键发布",
                  fn: this.publishScore,
                },
              ];
            } else {
              this.mainBtnArr = [
                {
                  title: "同步考试异常状态",
                  fn: this.examErrSync,
                  plain: true,
                },
                {
                  title: "考试异常状态导入",
                  fn: this.importStationDialogmsg,
                  plain: true,
                },
                {
                  title: "成绩试算",
                  fn: this.checkScore,
                  plain: true,
                },
                {
                  title: "设置合格证号规则",
                  fn: this.openCertificateRuleSetDialog,
                  plain: true,
                },
                {
                  title: "一键发布",
                  fn: this.publishScore,
                },

              ];
            }
          } else {
            if (this.getEnableScoreData == 1) {
              this.mainBtnArr = [
                {
                  title: "成绩导入",
                  fn: this.importStationDialog,
                  plain: true,
                },
                {
                  title: "考试异常状态导入",
                  fn: this.importStationDialogmsg,
                  plain: true,
                },
                {
                  title: "成绩试算",
                  fn: this.checkScore,
                  plain: true,
                },
                {
                  title: "设置合格证号规则",
                  fn: this.openCertificateRuleSetDialog,
                  plain: true,
                },
                {
                  title: "一键发布",
                  fn: this.publishScore,

                },
              ];
            } else {
              this.mainBtnArr = [
              {
                  title: "考试异常状态导入",
                  fn: this.importStationDialogmsg,
                  plain: true,
                },
                {
                  title: "成绩试算",
                  fn: this.checkScore,
                  plain: true,
                },
                {
                  title: "设置合格证号规则",
                  fn: this.openCertificateRuleSetDialog,
                  plain: true,
                },
                {
                  title: "一键发布",
                  fn: this.publishScore,

                },
              ];
            }
          }


          



        });
      });
    },
    /*********************************
     * @initCourseList 课程随着批次变化
     ********************************/
    async initCourseList(val) {
      /* *** 根据批次获取课程 *** */
      this.requestForm.courseIds = [];
      const { data: courseData } = await getPlanCourseFn({ planId: val });
      this.teaSelectList[1].data = courseData;
    },

    /********************************
     * @examErrSync 同步考试违纪状态
     ********************************/
    examErrSync() {
      this.$confirm("确认同步当前考试异常状态？", "提示", {
        type: "warning",
      })
        .then(() => {
          syncCheckStateSet({
            planId: this.requestForm.planId,
          }).then((res) => {
            if (res.code == 1) {
              this.$message.success("同步成功！");
            }
          });
        })
        .catch(() => {});
    },
    resetForm() {
      this.form = {
        courseName: "",
        scoreCalculateType: 1,
        scoreType: 1,
        rate: 60,
        passScore: "",
        excellentScore: "",
        form_gradeList: [{ score: "", name: "" }],
        outputScore: 0,
        outputScoreSub: 0
      };
    },
    async initData() {
      let { data } = await getSelectPlanFn({ needAudit: 6 });
      this.$set(this.teaSelectList[0], "data", data);
      if (data.length) {
        this.requestForm.planId = data[0].id;
        this.getCurrentInfo();
      }
      this.getScoreList();
    },
    // async initData() {
    //   let { data } = await getSelectPlanFn({ needAudit: 6 });
    //   this.$set(this.teaSelectList[0], "data", data);
    //   if (data.length) {
    //     this.requestForm.planId = data[0].id;
    //     this.getCurrentInfo();
    //   }
    //   this.getScoreList();
    // },
    // 当前考试批次
    async getCurrentInfo() {
      let res = await getCurrentPlanFn({
        planId: this.requestForm.planId,
      });
      this.currentPlan = res.data;
    },
    async getScoreList() {
      this.requestForm.type = 0;
      let params = Object.assign({}, this.requestForm, {
        courseIds: this.requestForm.courseIds.toString(),
        courseTypes: this.requestForm.courseTypes.toString(),
      });
      const { data } = await getPlanCoursePublishFn(params);
      this.tableData = data;
    },
    async checkScore() {
      this.requestForm.type = 1;
      let params = Object.assign({}, this.requestForm, {
        courseIds: this.requestForm.courseIds.toString(),
        courseTypes: this.requestForm.courseTypes.toString(),
      });
      const { data } = await getPlanCoursePublishFn(params);
      if (data) {
        this.tableData = data;
      }
    },
    checkSingleData(val) {
      const { courseId, scoreTypeId } = val;
      getPlanCoursePublishFn({
        type: 1,
        courseIds: courseId,
        courseTypes: scoreTypeId,
        planId: this.requestForm.planId,
      }).then(({ data }) => {
        const singleData = data.length && data[0];
        if (singleData) {
          this.tableData.forEach((item) => {
            if (item.courseId == singleData.courseId) {
              item.scoreTotalTest = singleData.scoreTotalTest;
            }
          });
        }
      });
    },
    /********************************
     * 合格证号的自定义规则
     ********************************/
    openCertificateRuleSetDialog() {
      this.certificateRuleSetDialog = true;
      this.certificateRuleActiveTab = 'default';
      this.certificateImportFile = null;
      this.certificateImportData = [];
      this.certificateImportPagination = { total: 0, page: 1, size: 10 };
      this.loadCertificateRuleData();
      this.getCertificateImportDataList();
    },
    async loadCertificateRuleData() {
      const planId = this.requestForm.planId;
      // 并行请求
      const [defaultRes, customRes, subjectRes] = await Promise.all([
        getSystemDefaultRuleCertAPI(),
        getCustomRuleByPlanIdCertAPI({ planId }),
        getSubjectListByPlanIdCertAPI({ planId })
      ]);
      // 默认规则
      if (defaultRes.data) {
        this.certSystemDefaultRules = [
          { key: 'key1', value: defaultRes.data.key1 || '' },
          { key: 'key2', value: defaultRes.data.key2 || '' },
          { key: 'key3', value: defaultRes.data.key3 || '' },
        ];
      }
      // 专业列表
      this.certSubjectList = subjectRes.data || [];
      // 自定义规则
      this.certSubjectRules = [];
      this.certGeneralRule = { customPrefix: '', numberLen: 4, numberStart: 1 };
      if (customRes.data && customRes.data.length > 0) {
        customRes.data.forEach(rule => {
          if (rule.generalFlag == 1) {
            this.certGeneralRule = {
              customPrefix: rule.customPrefix || '',
              numberLen: rule.numberLen || 4,
              numberStart: rule.numberStart || 1,
            };
          } else if (rule.subjectId) {
            this.certSubjectRules.push({
              subjectId: rule.subjectId,
              customPrefix: rule.customPrefix || '',
              numberLen: rule.numberLen || 4,
              numberStart: rule.numberStart || 1,
            });
          }
        });
      }
      // 为没有规则的专业初始化默认规则
      this.certSubjectList.forEach(subject => {
        if (!this.certSubjectRules.find(r => r.subjectId == subject.id)) {
          this.certSubjectRules.push({
            subjectId: subject.id,
            customPrefix: '',
            numberLen: 4,
            numberStart: 1,
          });
        }
      });
      this.certExpandedSubjects = this.certSubjectList.map(s => s.id);
    },
    getCertSubjectRule(subjectId) {
      return this.certSubjectRules.find(r => r.subjectId == subjectId);
    },
    generateCertExample(rule) {
      if (!rule || !rule.customPrefix) return '--';
      const start = rule.numberStart || 1;
      const len = rule.numberLen || 4;
      const numStr = String(start).padStart(len, '0');
      return rule.customPrefix + numStr;
    },
    async saveCertificateRuleSet() {
      // 如果有任一专业填写了自定义前缀，则其他专业也必须填写
      const hasSubjectPrefix = this.certSubjectRules.some(r => r.customPrefix);
      if (hasSubjectPrefix) {
        const emptySubject = this.certSubjectRules.find(r => !r.customPrefix);
        if (emptySubject) {
          const subjectObj = this.certSubjectList.find(s => s.id == emptySubject.subjectId);
          this.$message.warning(`专业"${subjectObj ? subjectObj.name : ''}"未填写自定义前缀，填写了任一专业前缀后，其他专业也必须填写`);
          return;
        }
      } else {
        if (!this.certGeneralRule.customPrefix) {
          this.$message.warning('请输入通用规则的自定义前缀');
          return;
        }
      }
      const planId = this.requestForm.planId;
      // 拼接通用规则：prefix#numberLen#numberStart
      const generalRule = `${this.certGeneralRule.customPrefix}#${this.certGeneralRule.numberLen}#${this.certGeneralRule.numberStart}`;
      // 拼接专业规则：prefix#numberLen#numberStart#subjectId,...
      const subjectParts = this.certSubjectRules
        .filter(r => r.customPrefix)
        .map(r => `${r.customPrefix}#${r.numberLen}#${r.numberStart}#${r.subjectId}`);
      const subjectRule = subjectParts.join(',');
      const params = { planId, generalRule, subjectRule };
      const { code } = await saveCustomRuleByPlanIdCertAPI(params);
      if (code == 1) {
        this.$message.success('保存成功！');
      }
    },
    async downloadCertificateTemplate() {
      const { code, data } = await certificateExportTemplateAPI({ planId: this.requestForm.planId });
      if (code == 1 && data) {
        window.open(data);
      }
    },
    handleCertificateImportFile(val) {
      this.certificateImportFile = val.file;
    },
    async doCertificateImport() {
      if (!this.certificateImportFile) {
        this.$message.error('请选择文件！');
        return;
      }
      const fd = new FormData();
      fd.append('planId', this.requestForm.planId);
      fd.append('file', this.certificateImportFile);
      const res = await certificateImportAPI(fd);
      if (res.code) {
        const failNum = res.data.errorCount ? parseInt(res.data.errorCount) : 0;
        const totalNum = parseInt(res.data.allCount);
        const successNum = totalNum - failNum;
        let message = `导入完成，成功导入${successNum}条。`;
        let errMessage = `导入失败：存在${failNum}条不符合要求的数据，请修改后重新导入。`;
        this.$confirm(failNum > 0 ? errMessage : message, '导入结果', {
          confirmButtonText: failNum > 0 ? '查看错误记录' : '确定',
          cancelButtonText: '取消',
          type: failNum > 0 ? 'warning' : 'success',
        }).then(() => {
          if (failNum > 0 && res.data.address) {
            window.open(res.data.address);
          }
        });
        this.getCertificateImportDataList();
      }
    },
    async getCertificateImportDataList() {
      const params = {
        planId: this.requestForm.planId,
        page: this.certificateImportPagination.page,
        size: this.certificateImportPagination.size,
      };
      const { data } = await certificateImportDataListAPI(params);
      if (data) {
        this.certificateImportData = data.records || [];
        this.certificateImportPagination.total = data.total || 0;
      }
    },
    handleCertificateImportPageChange(page) {
      this.certificateImportPagination.page = page;
      this.getCertificateImportDataList();
    },
    async publishScore() {
      //初始化成绩确认日期为当前时间
      const now = new Date();
      const pad = n => String(n).padStart(2, '0');
      this.confirmDate = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())}`;
      const { code:backCode , data:backScore } = await publishStudentScoreWarningFn({ planId: this.requestForm.planId });
      if(backCode === 1){
        this.beforeData.forbidList = backScore.forbid;
        this.beforeData.askList = backScore.ask;
        this.beforeData.windowList = backScore.window;
        this.beforeData.dialogFlag = backScore.forbid.length > 0 ? 1 : 2;
        this.beforeData.infoList = backScore.info;
      }
      return;
      //从这里往上都是新增代码，从这往下都是以前的代码，全都return掉，不要了
      this.$confirm("成绩发布后将无法撤销和修改，是否确定发布?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const { data } = await getPlanPartInfoAPI({planId: this.requestForm.planId});
        if (data.allowViewExamScoreFlag === 1) {
          this.publishScoreNext();
          return;
        }
        let { data: exemptNum } = await publishPreJudgeExemptAPI({ planId: this.requestForm.planId });
        if (exemptNum > 0) {
          this.exemptNum = exemptNum;
          this.publishScoreDialog = true;
        } else {
          this.publishScoreFn();
        }
      }).catch(() => {});
    },

    publishScoreNext() {
      this.$confirm("考试批次下设置了不允许学生查看成绩，发布后学生端无法查看，是否确定发布？", "提示", {
        confirmButtonText: "确定发布",
        cancelButtonText: "去设置",
        type: "warning",
      }).then(async () => {
        let { data: exemptNum } = await publishPreJudgeExemptAPI({ planId: this.requestForm.planId });
        if (exemptNum > 0) {
          this.exemptNum = exemptNum;
          this.publishScoreDialog = true;
        } else {
          this.publishScoreFn();
        }
      }).catch(() => {
        let planId = this.requestForm.planId;
        this.$router.push({name: "editBatch", query: {"id": planId}})
      });
    },

    async publishScoreFn() {
      const { code } = await publishStudentScoreFn({ planId: this.requestForm.planId, judgeExempt: 0, judgeThirdScore: 1, confirmDate: this.confirmDate });
      this.beforeData.dialogFlag = 0;
      if (code == 1) {
        this.$message.success("成绩发布成功，可到成绩查询功能查询");
        this.getScoreList();
        this.mixin_updateCurrentPlanInfo();
      }
    },

    // 下面这个是原版，没有改之前的代码
    // async publishScoreFn() {
    //   const { code } = await publishStudentScoreFn({ planId: this.requestForm.planId, judgeExempt: 0, judgeThirdScore: 1 });
    //   if (code == 1) {
    //     this.$message.success("成绩发布成功，可到成绩查询功能查询");
    //     this.getScoreList();
    //     this.mixin_updateCurrentPlanInfo();
    //   }
    //   this.publishScoreDialog = false;
    // },

    currentScore(row) {
      this.$router.push({
        name: "currentScore",
        query: {
          planCode: this.currentPlan.code,
          planName: this.currentPlan.name,
          planId: this.currentPlan.id,
          courseId: row.courseId,
          courseName: row.courseName,
          scorePublish: row.scorePublish,
        },
      });
    },
    changeSet(val) {
      this.courseName = val.courseName;
      this.form.planCourseId = val.planCourseId;
      this.form.scoreCalculateType = val.scoreCalculateType;
      this.form.scoreType = val.scoreType;
      this.haveSubCourseFlag = val.haveSubCourse==1 ? true : false;
      this.addDialog = true;
      this.CourseScore();
    },
    async CourseScore() {
      let { data } = await getCourseScore({
        planCourseId: this.form.planCourseId,
      });
      this.form.passScore = data.passScore;
      this.form.excellentScore = data.excellentScore;
      this.form.scoreCalculateType = data.scoreCalculateType;
      this.form.scoreType = data.scoreType;
      this.form.outputScore = data.outputScore;
      this.form.outputScoreSub = data.outputScoreSub;
      if (data.gradeSet) {
        let gradeSet = JSON.parse(data.gradeSet);
        this.form.form_gradeList = gradeSet;
      }
    },
    async setSubCourse (row) {
      this.setSubCourseDialog = true;
      this.nowPlanId = row.planId;
      this.nowCourseId = row.courseId;
      this.nowCourseName = row.courseName;
      this.corusePassScore = row.passScore;
      const { code,data } = await getPlanCourseSubListFn({
        planId : row.planId,
        courseId : row.courseId
      });
      if(code === 1){
        this.checkedCourseInfo = data.map(course => {
            return {
                id : course.subCourseId,
                name: course.courseSubName,
                scoreCalculateType: course.scoreCalculateType,
                passScore: course.passScore != null ? course.passScore : ''
            };
        });
      }else{
        this.$message.error('获取课程失败');
      }
      // this.$router.push({
      //   name: "setSubCourse",
      //   query: {
      //     planId: this.currentPlan.id,
      //     courseId: row.courseId,
      //     courseName: row.courseName,
      //     corusePassScore: row.passScore,
      //   },
      // });
    },
    async editSubCourse() {
      // 验证分数是否正确格式
      const hasEmptyScore = this.checkedCourseInfo.some(course => {
        const score = course.passScore;
        return typeof score !== 'number' || score < 0 || !Number.isInteger(score);
      });
      if (hasEmptyScore) {
        this.$message.error('请填写所有选中课程的通过分数线，且必须为大于等于0的整数');
        return;
      }
      //准备提交的数据
      const courseSubInfo = this.checkedCourseInfo.map(course => `${course.id}#${course.passScore}#${course.scoreCalculateType}`).join(',');
      try {
        const res = await editPlanCourseSubFn({
            planId : this.nowPlanId,
            courseId : this.nowCourseId,
            courseSubInfo: courseSubInfo
        });
        if (res.code === 1) {
          this.$message.success('设置成功');
          this.setSubCourseDialog = false;
        } else {
          this.$message.error('设置失败');
        }
      } catch (error) {
        this.$message.error('提交失败');
      }
    },
    seeCourseRule(){
      this.courseRuleDialog = true;
    },
    checkNextStep(){
      if(this.beforeData.windowList.length > 0){
        this.beforeData.dialogFlag = 3;
      }else{
        this.beforeData.dialogFlag = 0;
        this.publishScoreFn();
      }
    },
    changeSwitchState(val){
      this.form.outputScore = 0;
      this.form.outputScoreSub = 0;
    }
  },
};
</script>
<style lang="less" scoped>
.mainCon {
  padding: 20px;
  border-radius: 8px;
  background-color: #fff;
  flex: 1;
}
.setSubCourseDiv {
  margin-bottom: 20px;
  div{
    line-height: 45px;
  }
  span {
    width: 220px;
    display: inline-block;
    text-align: right;
    font-weight: bold;
    color:#707175;
  }
  
  .specialSpanTitle{
    width: 290px;
    display: inline-block;
    text-align: right ;
    font-weight: bold; 
    border: #707175 solid 0px;
    padding-right: 20px;
  }
  .specialSpanContent{
    width: 250px;
    display: inline-block;
    text-align: left ;
    font-weight: normal;
    border: #707175 solid 0px;
  }
  /deep/ .el-input{
    width: 120px;
  }
  /deep/ .el-input__inner{
    width: 120px;
  }
}
/deep/ .el-dialog{
  border-radius: 8px;
  font-family: "PingFangSC-Medium, PingFang SC";
}
.beforeWarning-title{
  font-size: 20px;
  font-weight: bold;
  color: #323335;
}
.beforeWarning-red{
  display: inline-block;
  margin-left: 8px;
  width: 23px;
  height: 23px;
  background-color: red;
  border-radius: 50%;
  color: white;
  text-align: center;
  line-height: 21px;
  font-weight: bold;
  position: relative;
  font-size: 17px;
  top: -3px;
}
.beforeWarning-blue{
  display: inline-block;
  margin-left: 8px;
  width: 22px;
  height: 22px;
  background-color: #3498DB;
  border-radius: 50%;
  color: white;
  text-align: center;
  line-height: 22px;
  font-weight: bold;
  position: relative;
  font-size: 17px;
  top: -1px;
}
.beforeWarning-yellow{
  display: inline-block;
  margin-left: 8px;
  width: 22px;
  height: 22px;
  background-color: #F39C12;
  border-radius: 50%;
  color: white;
  text-align: center;
  line-height: 22px;
  font-weight: bold;
  position: relative;
  font-size: 17px;
  top: -1px;
}
.beforePublishDialogCss {
  li , div {
    line-height: 35px;
  }
  ul{
    margin-left: 40px;
  }
  div{
    margin-left: 20px;
  }
  .col_red {
    font-size: 15px;
    font-weight: bold;
    color: #d15050;
  }
  .col_yellow {
    font-size: 16px;
    font-weight: bold;
    color: #E6A23C;
  }
  .col_nomarl {
    font-size: 14px;
    font-weight: bold;
  }
  .col_green {
    line-height: 140%;
    font-size: 14px;
    font-weight: 100;
    color: #315bbc;
    display: block;
    margin-top: 10px;
  }
  .confirm-date-box {
    margin-top: 8px;
    .confirm-date-row {
      display: flex;
      align-items: center;
    }
    .confirm-date-label {
      font-size: 14px;
      font-weight: bold;
    }
    .confirm-date-tip {
      font-size: 13px;
      color: #909399;
      margin-top: 4px;
      line-height: 20px;
    }
  }
}
.infoListCss{
  div ,li {
    line-height: 35px;
    display: flex;
  }
  .cScore{
    padding-left: 37px;
  }
  .cScore span{
    padding-left: 20px;
  }
  .cDiv{
    display: block;
  }
  .cDiv{
    padding-left: 22px;
  }
  ul {
    margin-left: 15px;
  }
  ul li {
    border-bottom: 1px solid #ecf0f1;
  }
  ul li span{
    padding-left: 20px;
  }
  .cScore > span:first-child,
  ul li > span:first-child  {
    width: 200px;
    padding-left: 0px;
  }
}
.eCardCss{
  width: 100%;
}
.eCardCss + .eCardCss {
  margin-top: 15px;
}
.courseSwitchCss{
  position: relative;
  border:1px solid #ccc;
  padding:15px;
  border-radius: 10px;
  margin-bottom: 18px;
  .switch1{
    line-height: 30px;
  }
  .switch2{
    line-height: 30px;
  }
  .font{
    color: red;
  }
}
.courseSwitchCss::before {
  content: '';
  position: absolute;
  top: -10px;
  left: var(--arrow-position);
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #ccc;
}
.courseSwitchCss::after {
  content: '';
  position: absolute;
  top: -9px;
  left: var(--arrow-position);
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  border-bottom: 9px solid white;
}

/* 合格证号规则设置弹窗样式 */

#pane-default {
  margin: auto; padding:2% 20%;
}
.cert-plan-name-tip {
  display: inline-flex;
  align-items: center;
  background: #f4f5f8;
  color: #45494d;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 14px;
  border-left: 3px solid #409eff;
  border-radius: 0 6px 6px 0;
  margin-bottom: 16px;
}
.cert-default-rule-list {
  display: flex;
  gap: 5px;
  margin-top: 20px;
}
.cert-default-rule-item {
  width: 32%;
  padding: 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #e9ebf0;
  word-break: break-all;
  letter-spacing: 1px;
  text-align: center;
}
.cert-bg-blue { background: #125283; }
.cert-bg-orange { background: #e3a061; }
.cert-bg-green { background: #54d384; }
.cert-default-rule-remark {
  margin-top: 16px;
  font-size: 13px;
  color: #737780;
}
.cert-custom-section-title {
  margin-bottom: 12px;
  color: #272e40;
}
.cert-custom-fieldset {
  border: 2px solid #dcdfe6;
  border-radius: 16px;
  padding: 16px 20px 8px;
  margin-bottom: 16px;
}
.cert-custom-legend {
  font-size: 14px;
  font-weight: 600;
  color: #272e40;
  padding: 0 8px;
  margin-left: 12px;
}
.cert-custom-rule-form {
  .el-form-item {
    margin-bottom: 8px;
  }
}
.cert-rule-example {
  color: #409EFF;
  font-size: 13px;
}
.cert-subject-title {
  font-weight: 500;
}
.cert-subject-example {
  margin-left: 16px;
  color: #409EFF;
  font-size: 13px;
}
.cert-import-section {
  margin-top: 16px;
}
.cert-import-row {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}
.cert-import-label {
  color: #737780;
  margin-right: 8px;
}
.cert-custom-rule-form /deep/ .el-form-item__label {
  line-height: 32px;
}
.cert-custom-rule-form /deep/ .el-input {
  width: 160px;
}
.cert-custom-rule-form /deep/ .el-input__inner {
  width: 160px;
  padding: 8px 8px 8px 12px !important;
}
.cert-custom-fieldset /deep/ .el-collapse-item__header {
  border: 0px;
  background-color: #f1f5f3 !important;
  padding-left: 20px !important;
}
</style>
